import { useState } from 'react';
import { Card } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import { getReservationsByProductType, price, showUpSell } from 'utils/helpers';
import { useCurrentBookingState } from 'utils/hooks/use_current_booking_state';
import LoadingSpinner from 'components/loading_spinner/loading_spinner';
import { deleteReservation } from 'redux/actions/reservation/delete';
import { getCurrentBooking } from 'redux/selectors/current_booking';
import ExperienceBody from './experience_body';

const Experiences = ({ onlyShowInfo = false }) => {
  const dispatch = useDispatch();
  const { isNewBooking, isFullyPaid: isBookingComplete } =
    useCurrentBookingState();

  const [showLoader, setShowLoader] = useState(false);
  const handleRemove = (bookingId, reservationId) => {
    setShowLoader(true);
    dispatch(deleteReservation(bookingId, reservationId)).finally(() => {
      setShowLoader(false);
    });
  };

  const currentBooking = useSelector(getCurrentBooking);
  const reservedExperience = getReservationsByProductType(
    'experience',
    currentBooking
  );

  const canRemoveReservation = isNewBooking && !isBookingComplete;

  const renderReservedExperiences = () =>
    reservedExperience.map((experience, index) => {
      const { id, booking_id } = experience;
      const isLast = reservedExperience.length === index + 1;
      const showRemoveButton = canRemoveReservation && !onlyShowInfo;

      return (
        <Card.Body className="py-0" key={id}>
          <div className="d-flex justify-content-end mb-2">
            <div className="me-2">
              {price(experience.gross_including_packaged_item_in_cents)}
            </div>
            {showRemoveButton && (
              <button
                type="button"
                onClick={() => handleRemove(booking_id, id)}
                className="link-danger text-decoration-underline text-small"
              >
                Remove
              </button>
            )}
          </div>
          <ExperienceBody experience={experience} />
          {!isLast && <hr className="my-3" />}
        </Card.Body>
      );
    });

  const noExperience = () => (
    <>
      {showUpSell('experience', currentBooking) ? (
        <div className="card-body--no-data card-body text-grey">
          Looking for something to do?
          <div>
            <a
              href={`${ecom.craftConfig.api_prefix}/experiences`}
              className="btn btn-outline-primary"
            >
              View experiences
            </a>
          </div>
        </div>
      ) : (
        <div className="card-body--no-data card-body">No experiences added</div>
      )}
    </>
  );

  const loading = () => (
    <div className="card-body--no-data card-body d-flex align-items-center justify-content-center">
      <LoadingSpinner text="Deleting reservation..." />
    </div>
  );

  if (showLoader) {
    return loading();
  }

  if (!isEmpty(reservedExperience)) {
    return <div className="py-2">{renderReservedExperiences()}</div>;
  }

  return noExperience();
};

export default Experiences;

Experiences.propTypes = {
  onlyShowInfo: PropTypes.bool,
};
